import React from 'react';
import { useTranslation } from 'react-i18next';
import FeaturedSectionStats from '../../ui/FeaturedSectionStats';
import './IntroSectionCyberData.css';

const IntroSectionCyberData3: React.FC = () => {
  const { t } = useTranslation();

  // Data for FeaturedSectionStats specific to Cyber Data
  const cyberDataStats = [
    {
      value: '100%',
      label: 'Protection données',
      translationKey: 'dataCyber.stats.protection',
      labelTranslationKey: 'dataCyber.stats.protectionLabel'
    },
    {
      value: '24/7',
      label: 'Surveillance continue',
      translationKey: 'dataCyber.stats.monitoring',
      labelTranslationKey: 'dataCyber.stats.monitoringLabel'
    },
    {
      value: '99.9%',
      label: 'Disponibilité système',
      translationKey: 'dataCyber.stats.availability',
      labelTranslationKey: 'dataCyber.stats.availabilityLabel'
    },
    {
      value: '∞',
      label: 'Conformité réglementaire',
      translationKey: 'dataCyber.stats.compliance',
      labelTranslationKey: 'dataCyber.stats.complianceLabel'
    }
  ];

  return (
    <div className="intro-section-home intro-section-cyber-data">
      <div className="intro-row-1 tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-8 tw-items-center tw-pt-[4em] max-[734px]:tw-pt-0">
        <div className="intro-text-1">
          <h2 style={{ fontSize: '62px', paddingBottom: '12px' }}>{t('dataCyber.introSection.commitment', 'Notre engagement')}</h2>
        </div>
      </div>

      <FeaturedSectionStats
        title="Une protection des données robuste et conforme aux réglementations."
        subtitle="Nous sécurisons vos données sensibles et vous accompagnons dans votre mise en conformité réglementaire pour une protection optimale."
        titleTranslationKey="dataCyber.stats.title"
        subtitleTranslationKey="dataCyber.stats.subtitle"
        stats={cyberDataStats}
        showChart={false}
      />
    </div>
  );
};

export default IntroSectionCyberData3;
